import {
  apiUrl,
  getList,
  deleteRecord,
  getSingleRecord,
  saveRecord,
  getStatsData,
  getAll,
  getAuditData,
  postAction,
  exportData,
} from './apiUtils';
import type { ApiListParamsWithUnderscores, ApiExportParams } from '../types/api/listParams';
import type { ListApiResponse } from '../types/apiResponse';
import type { Stats } from '../types/stats';
import type { PackageTypeModel } from '../types/api';

const baseUrl = apiUrl + '/packageTypes/';

export function getPackageTypes(
  params?: ApiListParamsWithUnderscores
): Promise<ListApiResponse<PackageTypeModel>> {
  return getList(`${baseUrl}search`, params);
}

export function getPackageTypeById(id: string): Promise<PackageTypeModel> {
  return getSingleRecord(baseUrl, id);
}

export function savePackageType(packageType: Partial<PackageTypeModel>): Promise<{ id: string }> {
  return saveRecord(baseUrl, packageType);
}

export function deletePackageType(id: string): Promise<{ id: string }> {
  return deleteRecord(baseUrl, id);
}

export function getStats(id: string): Promise<Stats> {
  return getStatsData(baseUrl, id);
}

export function getAudit(id: string): Promise<unknown> {
  return getAuditData(baseUrl, id);
}

export function addAudit(id: string, comment: string): Promise<unknown> {
  return postAction(`${baseUrl}${id}/audit`, { comment });
}

export function getAllPackageTypes(): Promise<PackageTypeModel[]> {
  return getAll(baseUrl);
}

export function exportPackageTypeData(params: ApiExportParams): Promise<void> {
  return exportData(`${apiUrl}/export/packageTypes/search`, 'name', params);
}
